module.exports = __webpack_public_path__ + "img/kakaxi.71e93a5c.gif";